import { render, staticRenderFns } from "./HistoryPanel.vue?vue&type=template&id=007bdd2b"
import script from "./HistoryPanel.vue?vue&type=script&lang=js"
export * from "./HistoryPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports